import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Card, SectionTitle } from '../../components/ui/Card';
import { useLocale } from '../../contexts/LocaleContext';
import { useMetrics } from '../../contexts/MetricsContext';
import type { UnitSystem } from '../../types';
const options: {
  id: UnitSystem;
  detail: string;
}[] = [{
  id: 'metric',
  detail: 'kg · km · cm · min/km · /100m'
}, {
  id: 'imperial',
  detail: 'lbs · mi · in · min/mi · /100yd'
}];
export function UnitsSettings() {
  const {
    t
  } = useLocale();
  const {
    unitSystem,
    setUnitSystem
  } = useMetrics();
  return <div className="px-2 pb-2" data-id="element-3996" data-mp="ju4g08qb7ud4">
      <PageHeader title={t('settings.units')} subtitle={t('units.subtitle')} showBack data-id="element-3997" data-mp="jq6ytsnalcvv" />

      <Card className="px-2" data-id="element-3998" data-mp="1v7gh4buopyvl">
        <ul role="radiogroup" aria-label={t('settings.units')} data-id="element-3999" data-mp="1v6f25wajss8l">
          {options.map(option => {
          const selected = unitSystem === option.id;
          return <li key={option.id} className="border-b border-sand-line last:border-b-0" data-id="element-4000" data-mp="gyjtd7j503mq">
                <button type="button" role="radio" aria-checked={selected} onClick={() => setUnitSystem(option.id)} className="flex min-h-[56px] w-full items-center gap-2 py-2 text-left" data-id="element-4001" data-mp="lwbums5o923l">
                  <span className="min-w-0 flex-1" data-id="element-4002" data-mp="3ud6pbkcbfg6l">
                    <span className="block text-[13.5px] font-medium text-deep" data-id="element-4003" data-mp="3uehqdcedm9u0">
                      {t(`units.${option.id}`)}
                    </span>
                    <span className="bee-num mt-[2px] block text-[11px] text-muted" data-id="element-4004" data-mp="856r3ez6npnz">
                      {option.detail}
                    </span>
                  </span>
                  <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-pill border ${selected ? 'border-gold bg-gold text-deep' : 'border-deep/25'}`} data-id="element-4005" data-mp="3bm6tbz6el63t">
                    {selected && <CheckIcon size={14} strokeWidth={3} data-id="element-4006" data-mp="38ir93z73o8a0" />}
                  </span>
                </button>
              </li>;
        })}
        </ul>
      </Card>

      <div className="mt-3" data-id="element-4007" data-mp="3i9c5dfzax0pr">
        <SectionTitle data-id="element-4008" data-mp="3i9lu708m11tv">{t('units.affects')}</SectionTitle>
        <Card className="p-2" data-id="element-4009" data-mp="3db0vx6cx4s82">
          <ul className="space-y-1" data-id="element-4010" data-mp="3dbsoe8b7y9u4">
            {['units.affects.body', 'units.affects.sports', 'units.affects.charts'].map(key => <li key={key} className="flex items-start gap-2 text-[12.5px] leading-snug text-deep" data-id="element-4011" data-mp="2kn4zm2r9h2bt">
                  <span className="mt-[6px] h-[5px] w-[5px] shrink-0 rounded-pill bg-gold" aria-hidden="true" data-id="element-4012" data-mp="2zht1l6xgdimo" />
                  {t(key)}
                </li>)}
          </ul>
        </Card>
      </div>
    </div>;
}